import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-font-awesome-layer-counter',
	templateUrl:'./FontAwesomeLayerCounterPluginCompPage.html',
	styles: [],
	styleUrls:['./FontAwesomeLayerCounterPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FontAwesomeLayerCounterPluginCompPage
{
	mdContent_932 = `\`\`\`java
import com.jwebmp.plugins.fontawesome5.FontAwesomeLayerCounter;
\`\`\``;
	mdContent_933 = `\`\`\`java
FontAwesomeLayerCounter()
\`\`\``;
	mdContent_934 = `\`\`\`java
var counter = new FontAwesomeLayerCounter<>()
    .setText("42");
\`\`\``;
}
